// Center-specific error messages
const CENTER_BASE_MESSAGES = {
  CENTER_INFRAESTRUCTURE: 'Error on retrieving center infraestructure',
  CENTER_DETAILS: 'Error on retrieving center details',
};

// RSABT-specific error messages
const RSABT_BASE_MESSAGES = {
  RSABTS: 'Error on retrieving RSABTS',
  RSABTS_MAP_VIEW: 'Error on retrieving RSABTs map view',
  RSABTS_CENTER_MAP_VIEW: 'Error on retrieving RSABTs center map view details',
  RSABTS_MAX_INTENSITY: 'Error on retrieving RSABTs maximum intensity data',
  RSABTS_MAX_TEMPERATURE: 'Error on retrieving RSABTs maximum temperature data',

  RSABT_LAST_SNAPSHOT_INTENSITY: 'Error on retrieving RSABT last snapshot Intensity',
  RSABT_LAST_SNAPSHOT_VOLTAGE_PHASES: 'Error on retrieving RSABT last snapshot Voltage Phases',
  RSABT_LAST_SNAPSHOT_WAVE_QUALITY: 'Error on retrieving RSABT last snapshot Wave Quality',

  RSABT_RANKING_CAPACITY: 'Error on retrieving RSABT ranking Capacity',
  RSABT_RANKING_MAX_TEMPERATURES: 'Error on retrieving RSABT last snapshot Maximum Temperatures',
  RSABT_RANKING_MAX_INTENSITY: 'Error on retrieving RSABT ranking Maximum Intensity',
  RSABT_INTENSITY_CHART: 'Error on retrieving RSABT intensity chart',

  RSABT_TEMPERATURE_CHART: 'Error on retrieving RSABT temperature chart',
  RSABT_INTENSITY_LINES_CHART: 'Error on retrieving RSABT intensity lines chart',
  RSABT_TEMPERATURE_LINES_CHART: 'Error on retrieving RSABT temperature lines chart',
  RSABT_VOLTAGE_CHART: 'Error on retrieving RSABT voltage chart',
  RSABT_WAVE_QUALITY_FLICKER_CHART: 'Error on retrieving RSABT wave quality flicker chart',
  RSABT_WAVE_QUALITY_VOLTAGE_IMBALANCE_CHART: 'Error on retrieving RSABT wave quality voltage imabalance chart',
  RSABT_WAVE_QUALITY_HARMONICS_CHART: 'Error on retrieving RSABT wave quality harmonics chart',
  RSABT_WAVE_QUALITY_FREQUENCY_CHART: 'Error on retrieving RSABT wave quality frequency chart',
  RSABT_VTN_TEMPERATURE_CHART: 'Error on retrieving RSABT vtn temperature chart',
  RSABT_VTN_VOLTAGE_CHART: 'Error on retrieving RSABT vtn voltage chart',
  RSABT_VTN_DATA: 'Error on retrieving RSABT vtn data',
  RSABT_VTN_CHART: 'Error on retrieving RSABT vtn chart',

  RSABT_INTENSITY_STATS: 'Error on retrieving RSABT intensity stats',
  RSABT_VOLTAGE_STATS: 'Error on retrieving RSABT voltage stats',
  RSABT_WAVE_QUALITY_FLICKER_STATS: 'Error on retrieving RSABT wave quality flicker stats',
  RSABT_WAVE_QUALITY_VOLTAGE_IMBALANCE_STATS: 'Error on retrieving RSABT wave quality voltage imbalance stats',
  RSABT_WAVE_QUALITY_HARMONIC_STATS: 'Error on retrieving RSABT wave quality harmonic stats',
  RSABT_WAVE_QUALITY_FREQUENCY_STATS: 'Error on retrieving RSABT wave quality frequency stats',
  RSABT_TEMPERATURE_STATS: 'Error on retrieving RSABT temperature stats',
};

// TSABT-specific error messages
const TSABT_BASE_MESSAGES = {
  TSABT_CHART: 'Error on retrieving TSABT chart',
  TSABT_INTENSITY_CHART: 'Error on retrieving TSABT intensity chart',
  TSABT_POWER_CHART: 'Error on retrieving TSABT power chart',
  TSABT_VOLTAGE_CHART: 'Error on retrieving TSABT voltage chart',
  TSABT_TEMPERATURE_CHART: 'Error on retrieving TSABT temperature chart',
  TSABT_POWER_INCOMING_ACTIVE_CHART: 'Error on retrieving TSABT power incoming active chart',
  TSABT_POWER_INCOMING_REACTIVE_CHART: 'Error on retrieving TSABT power incoming reactive chart',
  TSABT_POWER_OUTGOING_ACTIVE_CHART: 'Error on retrieving TSABT power outgoing active chart',
  TSABT_POWER_OUTGOING_REACTIVE_CHART: 'Error on retrieving TSABT power outgoing reactive chart',
  TSABT_POWER_TOTAL_CHART: 'Error on retrieving TSABT power total chart',

  TSABT_LEGEND_STATS: 'Error on retrieving TSABT legend stats',
  TSABT_PHASES_LEGEND_STATS: 'Error on retrieving TSABT phases legend stats',

  TSABT_RANKING_MAX_INTENSITY: 'Error on retrieving TSABT ranking Maximum Intensity',
};

// Alarm-specific error messages
const ALARMS_BASE_MESSAGES = {
  ALARM_STATUS_COUNT: 'Error on retrieving alarms status count',
  ALARM_PRIORITY_COUNT: 'Error on retrieving alarms priority count',
  GET_CATEGORY_ALARMS: 'Error on retrieving get category alarms',
  GET_ALARMS: 'Error on retrieving alarms',
  GET_ALARMS_MAP_VIEW: 'Error on retrieving alarms map view',
  GET_ALARMS_CENTER_MAP_VIEW: 'Error on retrieving alarms center map view details',
  ALARMS_DEACTIVATION_NOT_FOUND: 'Error deactivating alarms: not found',
};

// Event-specific error messages
const EVENTS_BASE_MESSAGES = {
  EVENTS_COUNT: 'Error on retrieving events count',
  GET_EVENTS_CENTER_MAP_VIEW: 'Error on retrieving events center map view details',
  EVENTS_MARK_READ_NOT_FOUND: 'Error marking events as read: not found',
};

// Admin-specific error messages
const ADMIN_BASE_MESSAGES = {
  CENTER_LIST: 'Error on retrieving center list',
  TRAFOS_LIST: 'Error on retrieving Trafos list',
  DISTRIBUTOR_DEFAULT: 'Error on retrieving distributor default configurations',
  LINES_LIST: 'Error on retrieving lines list',
  SAVE_CENTER: 'Error on saving center configurations',
  LT_BOX: 'Error on retrieving lv panel identifiers',
  LT_BOX_CONFIG: 'Error on retrieving lv panel configuration',
  UPDATE_LT_BOX_CONFIG: 'Error on updating lv panel configuration',
};

// Admin-specific error messages
const LOSSES_BASE_MESSAGES = {
  GET_AVERAGE_LOSSES: 'Error on retrieving average losses',
  GET_LAST_LOSSES: 'Error on retrieving last losses',
  GET_BALANCE_LOSSES: 'Error on retrieving balance losses',
  TSABT_LOSSES_CHART: 'Error on retrieving tsabt chart losses',
  RSABT_LOSSES_CHART: 'Error on retrieving rsabt chart losses',
  GET_LOSSES_CHART_DATA: 'Error on retrieving rsabt chart losses',
  GET_CENTER_SNAPSHOT: 'Error on retrieving center snapshot losses',
  CENTER_INFO_CARD: 'Error on retrieving center info card losses',
  TRAFO_INFO_CARD: 'Error on retrieving trafo info card losses',
};

/**
 * Defines the base messages with strict typing using `as const`.
 * Ensures that both the keys and values in `BASE_MESSAGES` are immutable and strictly typed.
 */
export const BASE_MESSAGES = {
  ...CENTER_BASE_MESSAGES,
  ...RSABT_BASE_MESSAGES,
  ...TSABT_BASE_MESSAGES,
  ...ALARMS_BASE_MESSAGES,
  ...EVENTS_BASE_MESSAGES,
  ...ADMIN_BASE_MESSAGES,
  ...LOSSES_BASE_MESSAGES,
} as const;


/**
 * Defines map with the constants to compare with the massage of error, to know if it is necessary to show a modal.
 */
export const toShowModalsConditionMap = new Map();
toShowModalsConditionMap.set("CENTER", 'centers not found');
toShowModalsConditionMap.set("TRAFO", 'transformers NOt found');
toShowModalsConditionMap.set("LINE", 'lines not found');
toShowModalsConditionMap.set("CONFIG", 'alarm configuration not found');
// toShowModalsConditionMap.set("DISTRIBUTOR", 'Configuration not found');
toShowModalsConditionMap.set("NOT_FOUND", 'resource not found');
toShowModalsConditionMap.set("ALARMS_NOT_FOUND", 'no alarms found for the given filters');
toShowModalsConditionMap.set("SAVE_CENTER", 'alarm configuration already exists for this distributor, center, transformer, line and device type combination');
toShowModalsConditionMap.set("INTERNAL_SERVER_ERROR", 'an unexpected error occurred');
toShowModalsConditionMap.set("UPDATE_LT_BOX_CONFIG", 'error on updating lv panel configuration');
